import { createContext, useContext, useState, ReactNode } from "react";
import TransformForm from "./TransformForm";

type Ctx = { open: () => void; close: () => void; isOpen: boolean };

const TransformFormCtx = createContext<Ctx>({
  open: () => {},
  close: () => {},
  isOpen: false,
});

export const useTransformForm = () => useContext(TransformFormCtx);

export const TransformFormProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <TransformFormCtx.Provider
      value={{ isOpen, open: () => setIsOpen(true), close: () => setIsOpen(false) }}
    >
      {children}
      <TransformForm open={isOpen} onClose={() => setIsOpen(false)} />
    </TransformFormCtx.Provider>
  );
};
